import { render, staticRenderFns } from "./HallmarkDonut.vue?vue&type=template&id=14659a79"
import script from "./HallmarkDonut.vue?vue&type=script&lang=js"
export * from "./HallmarkDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports